import numeral from 'numeral'
import masker from 'vanilla-masker'
import 'numeral/locales/pt-br'
import { padStart, debounce } from 'lodash'
import services from '@/services'
import { Notification as notify } from 'element-ui'

/*
 * Configura locales
 */
numeral.locale('pt-br')

/*
 * Extrai valor da primeira propriedade do objeto
 */
export function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

/*
 * Extrai valor da primeira propriedade do objeto
 */
export function extraiValorEnum(o) {
  if (typeof o !== 'object') return
  return Object.values(o)[0]
}

/*
 * Conterte timestamp para objeto Date
 */
export function makeDateFromTimestamp(timestamp) {
  return new Date(timestamp)
}

/*
 * Verifica se o valor informado é timestamp
 */
export function isNumber(value) {
  return new RegExp('^\\d+$').test(value)
}

/*
 * Verifica se o valor informado é timestamp
 */
export function isTimestamp(value) {
  return isNumber(isNumber) && new Date(value).getTime() > 0
}

/*
 * Conterte modea para numeral
 */
export function converteMoeda(string) {
  if (!isNaN(string)) {
    return Number(string)
  }
  if (!Number.isFinite(string)) {
    return numeral._.stringToNumber(string.toString())
  }
  return string
}

/*
 * Formata para moeda nacional
 */
export function formataMoeda(value, decimalPlaces = 2) {
  if (typeof value === 'string') {
    value = Number(value)
  }

  let pad = '00000000000'
  let decimals = pad.substring(0, decimalPlaces)
  return numeral(value).format('0,0.' + decimals)
}

/*
 * Formata Telefone
 */
export function formataTelefone(value) {
  if (typeof value !== 'undefined' && value !== null) {
    value = value.replace(/[^0-9]/g, '')
    return value.length > 10 ? masker.toPattern(value, '(99) 9 9999-9999') : masker.toPattern(value, '(99) 9999-9999')
  }
}

/*
 * Formata Cep
 */
export function formataCep(value) {
  if (typeof value !== 'undefined') {
    value = value.replace(/[^0-9]/g, '')
    return masker.toPattern(value, '99-999-999')
  }
}

/*
 * Formatação e validação de CPF/CNPJ (TRKM-2740).
 *
 * A implementação vive em `./documento`, que entende o CNPJ alfanumérico da
 * NT Conjunta 2025.001. Reexportado aqui para não quebrar os imports que já
 * apontam para `helpers`.
 */
export {
  formataCpf,
  formataCnpj,
  formataCpfCnpj,
  isCpf,
  isCnpj,
  isCpfCnpj,
  normalizaDocumento,
  MASCARA_CNPJ,
  MASCARA_CPF,
  REGEX_CNPJ
} from './documento'

/*
 * Formata para percentual
 */
export function formataPercencual(value) {
  return numeral(value).format('0%')
}

/*
 * Formata para data nacional
 */
export function formataData(value) {
  const options = {
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric',
    hour12: false,
  };

  value = isTimestamp(value) 
    ? makeDateFromTimestamp(value) 
    : value

  value = value.length > 10 
    ? new Intl.DateTimeFormat('pt-BR', options).format(new Date(value))
    : new Intl.DateTimeFormat('pt-BR').format(new Date(value))

  return value.replace(', 00:00:00', '')
}

/*
 * Formata número da carga
 */
export function formataNumeroCarga(value) {
  return value
}

/*
 * Filtra um array de forma recursiva
 */
export function filterDeep(array, value, recursive = 0) {
  let result = false

  return array.filter((line) => {
    if (result !== false) return true

    return Object.keys(line).some(function(k) {
      let v = line[k]

      if (typeof v !== 'object') {
        result =
          String(line[k])
            .toLowerCase()
            .indexOf(value.toLowerCase()) !== -1
        return result
      } else {
        if (typeof line[k][0] === 'undefined') {
          return Object.keys(line[k]).some(function(k2) {
            result =
              String(line[k][k2])
                .toLowerCase()
                .indexOf(value.toLowerCase()) !== -1
            return result
          })
        } else {
          if (line[k].length === filterDeep(line[k], value, 1).length) {
            return true
          }
        }
      }
    })
  })
}

/*
 * Calcula valor frete
 */
export async function calculaValorFrete(
  valorNotasFiscais,
  valorCarreteiro,
  valorDescarga,
  valorPedagio,
  valorGris,
  seguroTruckme = true,
  pessoaFisica = true,
  estadoOrigem,
  estadoDestino,
  embarcadorId
) {
  try {
    const data = (
      await services.Calculo.calcularFrete({
        valorNotasFiscais,
        valorCarreteiro,
        valorDescarga,
        valorPedagio,
        valorGris,
        seguroTruckme,
        pessoaFisica,
        estadoOrigem,
        estadoDestino,
        embarcadorId
      })
    ).data

    return {
      freteCarreteiro: data.freteCarreteiro,
      baseCalculo: data.baseCalculo,
      valorInssAutonomo: data.valorInssAutonomo,
      valorTaxaAdministrativa: data.valorTaxaAdministrativa,
      valorSeguro: data.valorSeguro,
      valorGris: data.valorGris,
      valorFrete: data.valorFrete,
      valorPayment: data.valorPayment,
      valorImpostos: data.valorImpostos,
      valorIcms: data.valorIcms,
      valorCst: data.valorCst,
      estadoOrigem: estadoOrigem,
      estadoDestino: estadoDestino
    }
  } catch (error) {
    notify.error({
      title: 'Erro',
      message: 'Não foi possível calular o valor de frete.'
    })
  }
}

/*
 * Confirma exclusão
 */
export function confirmar(title, text, callback1, callback2) {
  let config = {
    title: title,
    text: text,
    icon: 'warning',
    buttons: true,
    dangerMode: true
  }

  swal(config).then((confirm) => {
    if (confirm) {
      callback1()
    } else {
      callback2()
    }
    let classes = document.querySelector('.swal-overlay').className.split(' ')
    classes.pop()
    classes.join(' ')
    debounce(function() {
      document.querySelector('.swal-overlay').className = classes
    }, 1500)
  })

  document.querySelector('.swal-overlay').className += ' swal-overlay-warning'
}

/*
 * Calcular valor GRIS
 */
export function calculoGris(value) {
  return value + value * 0.05
}

/*
 * Força download
 */
export const forceDownloadXml = (function() {
  var link = document.createElement('a')
  document.body.appendChild(link)
  link.style = 'display: none'
  return function(data, fileName) {
    let json = data
    let blob = new Blob([json], { type: 'octet/stream' })
    let url = window.URL.createObjectURL(blob)

    link.href = url
    link.download = fileName
    link.target = '_blank'
    link.click()
    window.URL.revokeObjectURL(url)
  }
})()

/*
 * Força download Pdf
 */
export const forceDownloadPdf = (function() {
  let link = document.createElement('a')
  document.body.appendChild(link)
  link.style = 'display: none'
  return function(data, fileName) {
    let base64str = data
    let binary = atob(base64str.replace(/\s/g, ''))
    let len = binary.length
    let buffer = new ArrayBuffer(len)
    let view = new Uint8Array(buffer)

    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i)
    }

    let blob = new Blob([view], { type: 'application/pdf' })
    let url = window.URL.createObjectURL(blob)

    link.href = url
    link.download = fileName
    link.target = '_blank'
    link.click()
    window.URL.revokeObjectURL(url)
  }
})()

export const isJsonString = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}


// WEBPACK FOOTER //
// ./src/assets/js/helpers.js